// ReviewModal.jsx
import React, { useState } from "react";
import "./ReviewModal.css"
import {useAuth} from "../../context/AuthContext";
import Usuario from "../supabase/Usuario";

export default function ReviewModal({ producto, onClose }) {
    const [text, setText] = useState("");
    const [rating, setRating] = useState(5);
    const {user, logout} = useAuth()

    const handleSubmit = () => {
        Usuario.setResenna(user.numDocumento, producto.id, rating, text)
        Usuario.agregarVaritas(user.numDocumento, 3)
        console.log("Review submitted:", { producto, text, rating });
        onClose();
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <h3>Reseña para {producto.producto}</h3>
                <textarea
                    placeholder="Escribe tu reseña..."
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                />
                <select value={rating} onChange={(e) => setRating(Number(e.target.value))}>
                    <option value={1}>1⭐</option>
                    <option value={2}>2⭐</option>
                    <option value={3}>3⭐</option>
                    <option value={4}>4⭐</option>
                    <option value={5}>5⭐</option>
                </select>
                <div className="modal-actions">
                    <button className="modal-buttons" onClick={onClose}>Cancelar</button>
                    <button className="modal-buttons" onClick={handleSubmit}>Enviar</button>
                </div>
            </div>
        </div>
    );
}
